/**
 *
 * Asynchronously loads the component for CompleteSignUpV2
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "CompleteSignUpV2" */),
  loading: <Loading />
})
